module.exports = __webpack_public_path__ + "Flag-156.079dfdb8a1a905ef737470a99e8a59e5.svg";